import styled from 'styled-components';

export const Page = styled.div`
  max-width: 1919px;
  margin: 0 auto;
  padding-top: 38px;
  background: #f5f5f5;
`;
